import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Fade from '../../components/Fade';
import { calculateTopPadding } from './helpers';
import {
  TINY_BREAKPOINT_IN_PX,
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
  LAPTOP_BREAKPOINT_IN_PX,
} from '../../constants';

const DEFAULT_TOP_PADDING_IN_PX = 20;
const DEFAULT_BOTTOM_PADDING_IN_PX = 20;

const TextContentWrapper = styled.div`
  width: 100%;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    padding-top: 40px;
    width: auto;
    min-height: 50px;
    z-index: 1;
    justify-content: center;
  }
`;

// prettier-ignore
const TextContent = styled.div`
  width: 100%;
  max-width: 720px;
  box-sizing: border-box;
  padding-top: ${(props) => calculateTopPadding(props.paddingTop, props.isBackButtonVisible)}px;
  padding-right: 20px;
  padding-left: 50px;
  z-index: 2;

  @media screen and (max-width: ${LAPTOP_BREAKPOINT_IN_PX}px) {
    padding-top: 30px;
    padding-right: 5px;
    padding-left: 20px;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    padding-top: 20px;
    padding-left: 20px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    padding: 5px 20px ${(props) => props.isHomeScreen ? '0' : '25'}px 20px;
  }

  @media screen and (max-width: ${TINY_BREAKPOINT_IN_PX}px) {
    padding: 15px 15px 5px;
  }
`;

const TextColumnContent = ({
  paddingTop,
  paddingBottom,
  isBackButtonVisible,
  isHomeScreen,
  children,
}) => (
  <TextContentWrapper>
    <Fade>
      <TextContent
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        isBackButtonVisible={isBackButtonVisible}
        isHomeScreen={isHomeScreen}
      >
        {children}
      </TextContent>
    </Fade>
  </TextContentWrapper>
);

TextColumnContent.propTypes = {
  children: PropTypes.node.isRequired,
  paddingTop: PropTypes.number,
  paddingBottom: PropTypes.number,
  isBackButtonVisible: PropTypes.bool,
  isHomeScreen: PropTypes.bool,
};

TextColumnContent.defaultProps = {
  paddingTop: DEFAULT_TOP_PADDING_IN_PX,
  paddingBottom: DEFAULT_BOTTOM_PADDING_IN_PX,
  isBackButtonVisible: true,
  isHomeScreen: false,
};

export default TextColumnContent;
